import { useQuery } from 'react-query';
import { MeetingPresence } from 'src/core/types';

import axios from './axios';

export interface UseMeetingPresenceSummaryProps {
  id: number;
}

export function useMeetingPresenceSummary(
  props: UseMeetingPresenceSummaryProps,
) {
  const { id } = props;

  return useQuery<MeetingPresence[]>(
    ['meeting-presence', id],
    async () => {
      return axios
        .get<MeetingPresence[]>(
          `/posht/yashar/meetings/presence-summary/${id}/`,
        )
        .then((res) => res.data)
        .catch((error) => {
          if (error.response && error.response.status === 404) {
            return [];
          }
          throw error;
        });
    },
    {
      suspense: false,
    },
  );
}
